import { OSP_LIGHT } from './osp/themes/osp-light/theme';
import { Theme } from './theme.contract';
import { WACKER_NEUSON_DARK } from './wackerneuson/themes/wacker-neuson-dark/theme';
import { WACKER_NEUSON_LIGHT } from './wackerneuson/themes/wacker-neuson-light/theme';

export const THEMES: Theme[] = [
  OSP_LIGHT,
  WACKER_NEUSON_LIGHT,
  WACKER_NEUSON_DARK,
];
